<template>
  <Layout>
    <v-row justify="center" class="mt-4"> </v-row>
    <template v-if="loading">
      <v-skeleton-loader
        v-bind="attrs"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <template v-if="stockView">
        <v-row justify="between" align="center" class="my-2">
          <v-col cols="12" md="8">
            <v-row justify="end" justify-md="start" align="center">
              <v-col cols="12" sm="4">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="เลือกวันที่"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dates" range>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                    >
                      ยกเลิก
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(date)"
                    >
                      ตกลง
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  @change="onSelectBU"
                  v-model="selectBU"
                  multiple
                  :items="bu"
                  label="เลือก "
                  item-text="bu_name"
                  item-value="bu_id"
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="auto">
                <v-btn elevation="2" @click="search">ค้นหา</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-menu
              v-if="jobList.length > 0"
              :close-on-content-click="closeOnContentClick"
              left
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  ดาวน์โหลดรายงาน
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click="report(item.report)"
                  v-for="(item, index) in items"
                  :key="index"
                  :class="item.className"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-if="isEdit"
              elevation="2"
              @click="createJob"
              class="ml-3"
            >
              สร้างรายการนับสินค้า
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center" no-gutters>
          <v-col cols="12">
            <TableDashboard @delete="getData" />
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row justify="center" align="center">
          <v-alert type="error">{{ message }}</v-alert>
        </v-row>
      </template>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import TableDashboard from '@/components/TableDashboard'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      jobList: (state) => state.job.jobList,
      bu: (state) => state.masterData.bu,
      meLoading: (state) => state.me.isLoading,
      jobListLoading: (state) => state.job.isLoading,
      buLoading: (state) => state.masterData.isLoading,
      isEdit: (state) => state?.me?.data?.permission?.stock_edit,
      message: (state) => state?.error?.message,
    }),
    dateRangeText() {
      return this.dates.join(` ~ `)
    },
    loading() {
      return this.meLoading || this.buLoading
    },
    dates: {
      get() {
        return this.$store.state.job.selectDate
      },
      set(value) {
        const val = value.sort((a, b) => new Date(a) - new Date(b))
        this.$store.commit('job/SET_SELECT_DATE', val)
      },
    },
    stockView() {
      return this.me?.permission?.stock_view
    },
    buIds() {
      if (this.selectBU.length === 0) {
        return undefined
      } else if (
        this.selectBU.length === 1 &&
        this.selectBU[0] === 'all'
      ) {
        return undefined
      }
      return this.selectBU
    },
  },

  components: {
    TableDashboard,
    Layout,
  },

  data() {
    return {
      selectBU: ['all'],
      menu1: false,
      menu2: false,
      modal: false,
      closeOnContentClick: true,
      items: [
        {
          title: 'รายงานความคืบหน้า',
          report: 'stockProgressByDate',
          className: 'bg-yellow-light',
        },
        {
          title: 'รายงานสถานะการตรวจนับของร้าน',
          report: 'stockActivityByDate',
        },
        {
          title: 'รายงานการตรวจนับสต็อคสินค้า',
          report: 'checkedByDate',
        },
      ],
    }
  },

  mounted() {
    this.getData()
    this.$store.commit('job/RESET_JOB_DETAIL')
  },

  methods: {
    getData() {
      // Get master data
      this.$store.dispatch('masterData/getBu')
      this.getJob()
    },

    getJob() {
      const payload = {
        startDate: this.dates[0],
        endDate: this.dates[1],
        buIds: this.buIds,
      }
      this.$store.dispatch('job/getJoblist', payload)
    },

    createJob() {
      this.$router.push({
        name: 'CreateJob',
      })
    },

    search() {
      this.getJob()
    },

    onSelectBU(val) {
      if (this.selectBU.length > 0) {
        this.selectBU = this.selectBU.filter((i) => i !== 'all')
      } else {
        this.selectBU = ['all']
      }

      if (val?.[val?.length - 1] === 'all') {
        this.selectBU = ['all']
      } else if (val?.length === 1 && val[0] === 'all') {
        this.selectBU = ['all']
      }
    },

    async report(type) {
      const payload = {
        start_date: this.dates[0],
        end_date: this.dates[1],
        bu_id: this.buIds,
      }
      await this.$store.dispatch(`report/${type}`, payload)
    },
  },
}
</script>
